import type { LegacyRef } from 'react';
import React, { useContext, useEffect, useState } from 'react';

import { AppContext } from '../../../context/app';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './searchInput.module.scss';

type PlacesSearchInputProps = {
  placeholder?: string;
  onFocus: () => void;
  onChange: (value?: string) => void;
  onClear: () => void;
  value?: string;
};

const PlacesSearchInput: React.FC<PlacesSearchInputProps> = ({
  placeholder,
  onFocus,
  onChange,
  onClear,
  value,
}) => {
  const { navStartingPlace } = useContext(AppContext);
  const [hasFocus, setHasFocus] = useState(false);
  const [iconIsHovered, setIconIsHovered] = useState<boolean>(false);
  const ref = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    setHasFocus(document.activeElement === ref?.current);
  }, [ref, document.activeElement]);

  useEffect(() => {
    if (!navStartingPlace && ref?.current) {
      ref?.current?.focus();
    }
  }, [navStartingPlace, ref]);

  const handleClearSearch = () => {
    onClear();
    setIconIsHovered(false);
    ref?.current?.focus();
  };

  return (
    <div className={styles.container}>
      <input
        className={styles.search}
        name="startingLocationInput"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        placeholder={placeholder}
        ref={ref as unknown as LegacyRef<HTMLInputElement>}
        type="text"
        autoComplete="off"
      />
      {value ? (
        <div
          className={styles.icon}
          onMouseOver={() => setIconIsHovered(true)}
          onMouseLeave={() => setIconIsHovered(false)}
          onClick={handleClearSearch}
        >
          {navStartingPlace && !hasFocus && !iconIsHovered ? (
            <Icon
              icon={IconType.CHECK_CIRCLE}
              color="#50A66B"
              size={18}
              ariaLabel="Check Circle"
              ariaRole="status"
            />
          ) : (
            <Icon
              icon={IconType.CLOSE}
              size={18}
              ariaLabel="Close"
              ariaRole="button"
            />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default PlacesSearchInput;
